"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _pluralTranslations = require("../../../../../../localization/pluralTranslations");
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _CompactViewSwitch = _interopRequireDefault(require("../CompactViewSwitch"));
var _marker = _interopRequireDefault(require("./img/marker.svg"));
var _chart = _interopRequireDefault(require("./img/chart.svg"));
var _arrow = _interopRequireDefault(require("./img/arrow.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PriceAnalyticsHeader = function PriceAnalyticsHeader(_ref) {
  var isOpenChart = _ref.isOpenChart,
    isProccessSearch = _ref.isProccessSearch,
    totalHotels = _ref.totalHotels,
    onOpenMap = _ref.onOpenMap,
    onToggleAnalytic = _ref.onToggleAnalytic;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var hotelsTranslations = (0, _pluralTranslations.usePluralHotelsTranslation)();
  var headerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    headerRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultsControls,
    ref: headerRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultsCount
  }, totalHotels ? t('PRICE_ANALYTICS_DEFAULT_TITLE', {
    totalHotels: totalHotels,
    hotelWord: hotelsTranslations(totalHotels)
  }) : isProccessSearch && t('PRICE_ANALYTICS_LOADING_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultsButtons
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames2.default)(_styles.default.chartButton, _defineProperty({}, _styles.default.active, isOpenChart)),
    contentClassName: _styles.default.chartButtonText,
    icon: _chart.default,
    size: _Button.SIZES.LARGE,
    theme: isOpenChart ? _Button.THEMES.PURPLE : _Button.THEMES.WHITE,
    onClick: onToggleAnalytic
  }, t('TOGGLE_CHART_VISIBLING'), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.chartArrow,
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    }
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.onMapButton,
    disabled: !totalHotels,
    size: _Button.SIZES.LARGE,
    theme: _Button.THEMES.GRAY,
    onClick: onOpenMap
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.onMapInner
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.onMapIcon,
    dangerouslySetInnerHTML: {
      __html: _marker.default
    }
  }), t('OPEN_MODAL_MAP_BUTTON'))), /*#__PURE__*/_react.default.createElement(_CompactViewSwitch.default, null)));
};
PriceAnalyticsHeader.propTypes = {
  isOpenChart: _propTypes.default.bool.isRequired,
  isProccessSearch: _propTypes.default.bool.isRequired,
  totalHotels: _propTypes.default.number.isRequired,
  onOpenMap: _propTypes.default.func.isRequired,
  onToggleAnalytic: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(PriceAnalyticsHeader);